// Where scanners unknown to the database are put when they first authenticate
// (backend: src/project/default-project.ts). No member: super admins only.
export const DEFAULT_PROJECT_ID = 'default';
